import { ThemeContext } from '../../../constants/themes';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/atoms/Button';
import Type from '../../../components/atoms/Type';
import './index.css';

const YourRecordingRequestRow = ({ contentId, name, status, creditCost, type }) => {
  let history = useHistory();
  creditCost = !creditCost ? "(First Request Free)" : creditCost;

  const onClick = () => {
    history.push(`/listen/?content_id=${contentId}`);
  }

  return (
    <ThemeContext.Consumer>
      {themeContext => (
        <div className="recordingrow-div">
          <div className="recordingrow-name">
            <a href={type === 'labels' ? undefined : `https://${name}`} target="_blank"><Type style={{ textDecorationColor: themeContext.theme.text, margin: 0, color: type === 'labels' ? themeContext.theme.subtle : themeContext.theme.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</Type></a>
          </div>
          <div className="recordingrow-status">
            <Type style={{ margin: 0, color: type === 'labels' ? themeContext.theme.subtle : themeContext.theme.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{type === 'labels' ? 'Status' : status}</Type>
          </div>
          <div className="recordingrow-creditcost">
            <Type style={{ margin: 0, color: type === 'labels' ? themeContext.theme.subtle : themeContext.theme.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{creditCost}</Type>
          </div>
          {type === 'labels' ?
            (status === 'Fulfilled' ?
              <div className="recordingrow-status">

              </div>
              :
              null
            )
            :
            (status === 'Fulfilled' ?
              <div className="recordingrow-listen" style={{margin: 0, padding: 0}}>
                <Button type="secondary" value='Listen' onClick={onClick} />
              </div>
              :
              null
            )
          }
        </div>
      )}
    </ThemeContext.Consumer>
  )
}

export default YourRecordingRequestRow;